export const doTeamsOverlap = (facility, user) => {
  if (facility && user && user?.teams?.length) {
    // eslint-disable-next-line no-unsafe-optional-chaining
    for (const userTeam of user?.teams) {
      const foundIndex =
        facility.teams?.findIndex(
          (facilityTeam) => facilityTeam._id === userTeam._id,
        ) ?? -1;
      if (foundIndex >= 0) return true;
    }
    return false;
  }
  return true;
};
